module.exports = __webpack_public_path__ + "media/images/application/template/30-second-quote/both-02d2ea49fc385b11c1eda720bf9a80df.png";